import gql from 'graphql-tag';

export default gql`
  {
    allSchools {
      id
      schoolId
      name
      address1
      address2
      city
      state
      zip
      county
      districtId
      districtName
      type
      gradesServed
      teachersAidSchoolNumber
      teamMembersBackpackBuddy {
        teamMemberId
        firstName
        lastName
        title
        phone
        email
        type
      }
      teachers {
        teacherId
        firstName
        lastName
        title
        phone
        email
        gradesTaught
        subjectsTaught
        numStudentsTaughtPerYear
      }
      primaryPointOfContact {
        teamMemberId
        firstName
        lastName
        title
        phone
        email
        type
      }
      siteCoordinator {
        teamMemberId
        firstName
        lastName
        title
        phone
        email
        type
      }
      principal {
        teamMemberId
        firstName
        lastName
        title
        phone
        email
        type
      }
    }
  }
`;
